import { apiRequest, apiRequestPaginated } from './client';
import type { AppNotification } from '../types';

type ApiNotification = {
  _id: string;
  title?: string;
  description?: string;
  createdAt?: string;
};

export const mapApiNotification = (n: ApiNotification): AppNotification => ({
  id: n._id,
  title: n.title || '—',
  message: n.description || '',
  target: 'Specific User',
  recipientCount: 0,
  createdAt: n.createdAt || '',
  status: 'Sent',
  recipients: [],
});

export const notificationsApi = {
  getNotifications: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<{ notifications: AppNotification[]; total: number }> => {
    const query = new URLSearchParams({
      page: String(params?.page || 1),
      limit: String(params?.limit || 1000),
    });

    const { data, pagination } = await apiRequestPaginated<{
      notifications: ApiNotification[];
    }>(`/admin/notification/get-notifications?${query.toString()}`, {
      method: 'GET',
      auth: true,
    });

    return {
      notifications: (data.notifications || []).map(mapApiNotification),
      total: pagination.totalItems || 0,
    };
  },

  createNotification: async (title: string, description: string): Promise<void> => {
    await apiRequest('/admin/notification/create-notification', {
      method: 'POST',
      auth: true,
      body: { title, description },
    });
  },

  readNotification: async (notificationID: string): Promise<void> => {
    await apiRequest('/admin/notification/read-notification', {
      method: 'POST',
      auth: true,
      body: { notificationID },
    });
  },

  getNotificationById: async (id: string): Promise<AppNotification> => {
    const { notifications } = await notificationsApi.getNotifications({
      page: 1,
      limit: 1000,
    });
    const found = notifications.find((n) => n.id === id);
    if (!found) throw new Error('Notification not found');
    return found;
  },
};
